import { Fragment, FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import styles from './childListDialog.module.scss'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { ChildCareOutlined, Close } from '@mui/icons-material'
import Desktop from '@/modules/desktopMobile/desktop'
import moment from 'moment-timezone'
import { Child } from '@/types/Child'
import { getPrimarySection } from '@/modules/helper/childHelper'
import { NavigateFunction, useNavigate } from 'react-router-dom'

interface ChildListDialogProps {
    isDialogOpen: boolean
    handleCloseDialog: () => void
    childs: Child[]
    currentDaycareId: number
    isRpeOrLaep: boolean
}

const ChildListDialog: FunctionComponent<ChildListDialogProps> = ({
    isDialogOpen,
    handleCloseDialog,
    childs,
    currentDaycareId,
    isRpeOrLaep
}: ChildListDialogProps) => {
    const { t } = useTranslation()

    const navigate: NavigateFunction = useNavigate()

    return (
        <Dialog open={isDialogOpen} handleClose={handleCloseDialog} className={styles.Dialog}>
            <DialogHeader title={t('childList')} />
            <DialogBody className={styles.DialogBody}>
                <TableContainer className={styles.TablePlacement}>
                    <Table className={styles.Table}>
                        <TableHead className={styles.TableHeader}>
                            <TableRow>
                                <TableCell />
                                <TableCell>{t('lastname')}</TableCell>
                                <TableCell>{t(isRpeOrLaep ? 'sector' : 'section')}</TableCell>
                                <Desktop>
                                    <TableCell>{t('birthdate')}</TableCell>
                                </Desktop>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {childs.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={2}>{t('noChilds')}</TableCell>
                                </TableRow>
                            ) : (
                                childs.map(({ id, firstname, birthdate, daycares }, index) => (
                                    <TableRow key={index.toString() + id} onClick={() => navigate(`?child=${id}`)}>
                                        {daycares.length > 0 &&
                                            daycares
                                                .filter((daycare) => daycare.daycareId === currentDaycareId)
                                                .map(({ complement, sections }, index) => (
                                                    <Fragment key={index}>
                                                        <TableCell>
                                                            <div className={styles.IconContainer}>
                                                                <ChildCareOutlined
                                                                    className={styles.Icon}
                                                                    onClick={() => navigate(`?child=${id}`)}
                                                                />
                                                            </div>
                                                        </TableCell>
                                                        <TableCell>
                                                            {firstname ? (
                                                                firstname + (complement ? ' - ' + complement : '')
                                                            ) : (
                                                                <div className={styles.IconContainer}>
                                                                    <Close className={styles.CloseIcon} />
                                                                </div>
                                                            )}
                                                        </TableCell>
                                                        <TableCell>
                                                            {sections.length > 0 ? (
                                                                getPrimarySection(sections)
                                                            ) : (
                                                                <div className={styles.IconContainer}>
                                                                    <Close className={styles.CloseIcon} />
                                                                </div>
                                                            )}
                                                        </TableCell>
                                                    </Fragment>
                                                ))}
                                        <Desktop>
                                            <TableCell>
                                                {birthdate ? (
                                                    moment(birthdate, 'DD-MM-YYYY').format('DD/MM/YYYY')
                                                ) : (
                                                    <div className={styles.IconContainer}>
                                                        <Close className={styles.CloseIcon} />
                                                    </div>
                                                )}
                                            </TableCell>
                                        </Desktop>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'close'} onClick={handleCloseDialog} className={styles.Button} />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ChildListDialog
